import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import { __decorate } from "tslib";
import { Component, createRef } from 'intact-vue';
import template from './search.vdt';
import { sizes } from '../../styles/utils';
import { _$ } from '../../i18n';
import { bind } from '../utils';
import { useDocumentClick } from '../../hooks/useDocumentClick';
import { useConfigContext } from '../config';
var typeDefs = {
  placeholder: String,
  value: String,
  type: ['default', 'line'],
  size: sizes,
  open: Boolean
};
var defaults = function defaults() {
  return {
    get placeholder() {
      return _$('请输入关键字');
    },
    value: '',
    type: 'default',
    size: 'default',
    open: false
  };
};
export var Search = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Search, _Component);
  function Search() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.elementRef = createRef();
    _this.inputRef = createRef();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Search.prototype;
  _proto.init = function init() {
    useDocumentClick(this.elementRef, this.hide.bind(this));
  };
  _proto.open = function open() {
    this.set('open', true);
    this.inputRef.value.select();
  };
  _proto.hide = function hide() {
    this.set('open', false);
  };
  _proto.onClickBtn = function onClickBtn() {
    // if the box is open, then submit the form
    if (this.get('open')) {
      this.submit();
    } else {
      this.open();
    }
  };
  _proto.onChangeValue = function onChangeValue(v) {
    if (!this.get('open')) return;
    this.set('value', v);
  };
  _proto.onSubmit = function onSubmit(e) {
    e.preventDefault();
    this.submit();
  };
  _proto.submit = function submit() {
    var _context2;
    this.trigger('submit', _trimInstanceProperty(_context2 = this.get('value')).call(_context2));
  };
  return Search;
}(Component);
Search.template = template;
Search.typeDefs = typeDefs;
Search.defaults = defaults;
__decorate([bind], Search.prototype, "onClickBtn", null);
__decorate([bind], Search.prototype, "onChangeValue", null);
__decorate([bind], Search.prototype, "onSubmit", null);